<template>
  <div style="text-align: center">
    <!-- 登录二维码 -->
    <div id="ding_login_container" ref="loginContainer">

    </div>
    <div v-if="isAuth">
      <Spin fix>
      </Spin>
      扫描成功...
    </div>
  </div>
</template>
<script>
  let appid = "dingoatz1qoekuxwg65olq";
  let reUrl = `http://dev.qiein.com/ding_auth`;
  var gotoUrl = encodeURIComponent("https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=" + appid +
    "&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=" + reUrl);

  import {
    getUrlParam
  } from "../../common/util"
  import {
    Spin
  } from 'iview'
  //声明对象
  window.dingAuthObj = null;
  export default {
    name: 'ding-auth',
    components: {
      Spin,
    },
    data() {
      return {
        //是否已经得到了CODE
        isAuth: false
      }
    },
    created: function () {
      window.dingAuthObj = this;
    },
    mounted: function () {
      this.checkHasLoginCode();
      if (!this.isAuth) {
        this.addListen();
        this.getQRCode();
      }
    },
    methods: {
      //获取二维码
      getQRCode() {
        let qrCode = DDLogin({
          id: "ding_login_container", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
          goto: gotoUrl,
          style: `border:none;background-color:#FFFFFF;width:100%;height100%" hhhhhh`,
          width: "230",
          height: "300"
        });
        window.frames['ding-auth-iframe'].document;
      },
      addListen() {
        if (typeof window.addEventListener != 'undefined') {
          window.addEventListener('message', this.getAuthCode, false);
        } else if (typeof window.attachEvent != 'undefined') {
          window.attachEvent('onmessage', this.getAuthCode);
        }
      },
      //获取auth code值
      getAuthCode(event) {
        var origin = event.origin;
        if (origin == "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
          var loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          let src =
            `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${reUrl}&loginTmpCode=${loginTmpCode}`;
          //让钉钉的窗口跳转
          document.getElementById('ding-auth-iframe').src = src
        }
      },
      //检查参数是否有登录值，有的话，说明是跳转过来的
      checkHasLoginCode() {
        let param = getUrlParam();
        if (param.code) {
          //   console.log(param.code)
          this.isAuth = true;
          this.loginTmpCode = param.code;
          window.parent.dingAuthObj.emitCode(param.code);
        }
      },
      //提交值
      emitCode(code) {
        this.$emit('get-code', code);
        window.dingAuthObj = null;
      }
    }
  }

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/sing-in/ding-auth.vue